// // Components/AddConductorModal.jsx

// import React, { useState } from 'react';
// import { toast } from 'react-toastify';
// import { addConductor } from '../../Services/Operations/ProductAPI';

// const AddConductorModal = ({ busOwnerId, token, onClose, onSuccess }) => {
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     name: '',
//     mobileNumber: '',
//     email: '',
//     address: '',
//     emergencyContact: '',
//     assignedBus: ''
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       // Validate required fields
//       if (!formData.name.trim()) {
//         toast.error('Conductor name is required');
//         setLoading(false);
//         return;
//       }

//       if (!formData.mobileNumber.trim()) {
//         toast.error('Mobile number is required');
//         setLoading(false);
//         return;
//       }

//       // Prepare data for API
//       const conductorData = {
//         name: formData.name.trim(),
//         mobileNumber: formData.mobileNumber.trim(),
//         busOwner: busOwnerId,
//         email: formData.email.trim() || null,
//         address: formData.address.trim() || null,
//         emergencyContact: formData.emergencyContact.trim() || null,
//         assignedBus: formData.assignedBus || null
//       };

//       const response = await addConductor(conductorData, token);

//       if (response.success) {
//         toast.success('Conductor added successfully');
//         if (onSuccess) onSuccess(response.data);
//         onClose();
//       } else {
//         toast.error(response.message || 'Failed to add conductor');
//       }
//     } catch (error) {
//       console.error('Error adding conductor:', error);
//       toast.error(error.response?.data?.message || 'Failed to add conductor');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="fm-modal-overlay" onClick={onClose}>
//       <div className="fm-modal-content fm-glass-effect add-staff-modal" onClick={(e) => e.stopPropagation()}>
//         <div className="fm-modern-header">
//           <div className="fm-header-content">
//             <div className="fm-header-title">
//               <div className="fm-header-icon-wrapper">
//                 <span>👥</span>
//               </div>
//               <div className="fm-header-text">
//                 <h1>Add New Conductor</h1>
//                 <p>Enter conductor details to register</p>
//               </div>
//             </div>
//             <button className="fm-close-button" onClick={onClose}>×</button>
//           </div>
//         </div>

//         <div className="fm-modal-body add-staff-body">
//           <form onSubmit={handleSubmit} className="fm-add-staff-form">
//             <div className="fm-form-grid">
//               {/* Name */}
//               <div className="fm-form-group full-width">
//                 <label className="fm-form-label">
//                   Full Name <span className="fm-required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   placeholder="Enter conductor's full name"
//                   className="fm-form-input"
//                   required
//                 />
//               </div>

//               {/* Mobile Number */}
//               <div className="fm-form-group">
//                 <label className="fm-form-label">
//                   Mobile Number <span className="fm-required">*</span>
//                 </label>
//                 <input
//                   type="tel"
//                   name="mobileNumber"
//                   value={formData.mobileNumber}
//                   onChange={handleChange}
//                   placeholder="10-digit mobile number"
//                   className="fm-form-input"
//                   maxLength="10"
//                   required
//                 />
//               </div>

//               {/* Email */}
//               <div className="fm-form-group">
//                 <label className="fm-form-label">Email Address</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   placeholder="conductor@example.com"
//                   className="fm-form-input"
//                 />
//               </div>

//               {/* Emergency Contact */}
//               <div className="fm-form-group">
//                 <label className="fm-form-label">Emergency Contact</label>
//                 <input
//                   type="tel"
//                   name="emergencyContact"
//                   value={formData.emergencyContact}
//                   onChange={handleChange}
//                   placeholder="10-digit emergency number"
//                   className="fm-form-input"
//                   maxLength="10"
//                 />
//               </div>

//               {/* Address */}
//               <div className="fm-form-group full-width">
//                 <label className="fm-form-label">Address</label>
//                 <textarea
//                   name="address"
//                   value={formData.address}
//                   onChange={handleChange}
//                   placeholder="Enter full address"
//                   className="fm-form-textarea"
//                   rows="2"
//                 />
//               </div>
//             </div>

//             <div className="fm-form-actions">
//               <button type="button" className="fm-cancel-btn" onClick={onClose}>
//                 Cancel
//               </button>
//               <button type="submit" className="fm-submit-btn" disabled={loading}>
//                 {loading ? (
//                   <>
//                     <span className="fm-spinner-small"></span>
//                     Adding...
//                   </>
//                 ) : (
//                   '👥 Add Conductor'
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddConductorModal;

// Components/AddConductorModal.jsx

import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { addConductor } from '../../Services/Operations/ProductAPI';

const AddConductorModal = ({ busOwnerId, token, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    mobileNumber: '',
    assignedBus: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate required fields
      if (!formData.name.trim()) {
        toast.error('Conductor name is required');
        setLoading(false);
        return;
      }

      if (!formData.mobileNumber.trim()) {
        toast.error('Mobile number is required');
        setLoading(false);
        return;
      }

      // Prepare data for API
      const conductorData = {
        name: formData.name.trim(),
        mobileNumber: formData.mobileNumber.trim(),
        busOwner: busOwnerId,
        assignedBus: formData.assignedBus || null
      };

      const response = await addConductor(conductorData, token);

      if (response.success) {
        toast.success('Conductor added successfully');
        if (onSuccess) onSuccess(response.data);
        onClose();
      } else {
        toast.error(response.message || 'Failed to add conductor');
      }
    } catch (error) {
      console.error('Error adding conductor:', error);
      toast.error(error.response?.data?.message || 'Failed to add conductor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fm-modal-overlay" onClick={onClose}>
      <div className="fm-modal-content fm-glass-effect add-staff-modal" onClick={(e) => e.stopPropagation()}>
        <div className="fm-modern-header">
          <div className="fm-header-content">
            <div className="fm-header-title">
              <div className="fm-header-icon-wrapper">
                <span>👥</span>
              </div>
              <div className="fm-header-text">
                <h1>Add New Conductor</h1>
                <p>Enter conductor details to register</p>
              </div>
            </div>
            <button className="fm-close-button" onClick={onClose}>×</button>
          </div>
        </div>

        <div className="fm-modal-body add-staff-body">
          <form onSubmit={handleSubmit} className="fm-add-staff-form">
            <div className="fm-form-grid">
              {/* Name */}
              <div className="fm-form-group full-width">
                <label className="fm-form-label">
                  Full Name <span className="fm-required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter conductor's full name"
                  className="fm-form-input"
                  required
                />
              </div>

              {/* Mobile Number */}
              <div className="fm-form-group">
                <label className="fm-form-label">
                  Mobile Number <span className="fm-required">*</span>
                </label>
                <input
                  type="tel"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  placeholder="10-digit mobile number"
                  className="fm-form-input"
                  maxLength="10"
                  required
                />
              </div>
            </div>

            <div className="fm-form-actions">
              <button type="button" className="fm-cancel-btn" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="fm-submit-btn" disabled={loading}>
                {loading ? (
                  <>
                    <span className="fm-spinner-small"></span>
                    Adding...
                  </>
                ) : (
                  '👥 Add Conductor'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddConductorModal;